<template>
    <nav>
        <ul class="c-nav c-nav--vertical c-nav--arrowed">
            <li><a @click.prevent="changeLanguage('en')" :class="{'is-active': currentLanguage === 'en'}" href="#">English</a></li>
            <li><a @click.prevent="changeLanguage('nl')" :class="{'is-active': currentLanguage === 'nl'}" href="#">Nederlands</a></li>
            <li><a @click.prevent="changeLanguage('fr')" :class="{'is-active': currentLanguage === 'fr'}" href="#">Français</a></li>
        </ul>
    </nav>
</template>

<style lang="scss" scoped>

    @import "~@/assets/scss/private";

</style>

<script>
    export default {
        data() {
            return {locale: 'en'}
        },
        computed: {
            currentLanguage() {
                return this.$i18n.locale;
            }
        },
        methods: {
            changeLanguage(locale) {
                let brands = '';
                let params = window.location.search.split('&');
                for(let i = 0; i < params.length; i++) {
                    let pair = params[i].split('=');
                    if (pair[0] === 'Brands') {
                        brands =  '?' + pair[0] + '=' + pair[1];
                    }
                }

                history.pushState(null, null, "/"+locale+window.location.pathname.substring(3) + brands);
                window.location.reload(false);
            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/components/LanguageNav.vue